module.exports = __webpack_public_path__ + "public/img/device.719efa4c.png";